<ion-content>
  @if (gameDetails$ | async; as gameInfo) {
    <div>
      <div class="hero-img">
        <ion-buttons class="backArrow" slot="start" (click)="goBack()">
          <ion-icon name="arrow-back"></ion-icon>
        </ion-buttons>
        <ion-img src="{{ gameInfo?.game_popup_image_url }}"></ion-img>
      </div>
      <!-- Main container starts here -->
      <div class="main-con">
        <ion-text>
          <h1>
            {{
            ("game_details_page.total_prizes" | translate)
            ? ("game_details_page.total_prizes" | translate)
            : "Total prizes"
            }}: {{ gameInfo?.total_prize }}
          </h1>
          <span class="light-color"
            >{{ flashCost?.sales_cost || gameInfo?.game_price }}
            {{
            ("game_details_page.points_per_play" | translate)
            ? ("game_details_page.points_per_play" | translate)
            : "points per play"
            }}</span
            >
            <p>{{ gameInfo?.game_popup_details }}</p>
            @if (gameInfo?.learn_more_rules) {
              <p>{{ gameInfo?.learn_more_rules }}</p>
            }
          </ion-text>
        </div>
        <div class="main-con custom-rating-grid">
          <!-- progress-section section starts here -->
          <!-- <section class="progress-section">
          <h2 class="title">
            {{
            ("game_details_page.your_progress" | translate)
            ? ("game_details_page.your_progress" | translate)
            : "Your progress"
            }}
          </h2>
          <ion-grid>
            <ion-row class="ion-justify-content-center">
              <ion-col
                *ngFor="let rating of gameInfo?.goal_details; let i = index"
                size="3"
                size-sm="4"
                class="ion-no-padding progress-box-alignment"
                >
                <div *ngIf="i < 8">
                  <div class="progress-box">
                    <div
                      *ngIf="rating?.goal_status != 'Locked'"
                      class="inner-box"
                    [ngClass]="{
                      'orange-bg': rating?.goal_status == 'Next',
                      'unlocked-color': rating.star_collected > 0
                    }"
                      >
                      {{ rating?.goal_number }}
                    </div>
                    <div class="inner-box" *ngIf="rating?.goal_status == 'Locked'">
                      <img src="assets/images/lock.svg" alt="Lock" />
                    </div>
                    <div *ngIf="rating.star_collected > 0" class="stars-con">
                      <ul>
                        <li>
                          <img
                            class="two-stars"
                          [src]="
                            rating.star_collected > 0
                              ? 'assets/images/small-star.svg'
                              : 'assets/images/star-inactive.svg'
                          "
                            alt="Lock"
                            />
                          </li>
                          <li class="more-space">
                            <img
                              class="center-star"
                          [src]="
                            rating.star_collected > 1
                              ? 'assets/images/small-star.svg'
                              : 'assets/images/star-inactive.svg'
                          "
                              alt="Lock"
                              />
                            </li>
                            <li>
                              <img
                                class="two-stars"
                          [src]="
                            rating.star_collected > 2
                              ? 'assets/images/small-star.svg'
                              : 'assets/images/star-inactive.svg'
                          "
                                alt="Lock"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </section> -->
            </div>
            <div class="main-con">
              <!-- <section class="progress-section">
              <ion-grid class="lock-alignment">
                <ion-row class="ion-align-items-center">
                  <ion-col style="text-align: center" size="2">
                    <ion-button (click)="slidePrev()" class="backBtn activePrev" id="slidePrev">
                      <ion-icon class="arrow-left" name="arrow-back"></ion-icon>
                    </ion-button>
                  </ion-col>
                  <ion-col size="8">
                    <swiper #progressSlides [config]="slidesOptions" class="bullets-slider">
                      <ng-template
                        swiperSlide
                  *ngFor="
                    let rating of gameInfo?.goal_details | slice : 8 : gameInfo?.goal_details?.length - 1;
                    let i = index
                  "
                        >
                        <div class="progress-box">
                          <div
                            *ngIf="rating?.goal_status != 'Locked'"
                            class="inner-box"
                      [ngClass]="{
                        'orange-bg': rating?.goal_status == 'Next',
                        'unlocked-color': rating.star_collected > 0
                      }"
                            >
                            {{ rating?.goal_number }}
                          </div>
                          <div class="inner-box" *ngIf="rating?.goal_status == 'Locked'">
                            <img src="assets/images/lock.svg" alt="Lock" />
                          </div>
                          <div *ngIf="rating.star_collected > 0" class="stars-con">
                            <ul>
                              <li>
                                <img
                                  class="two-stars"
                            [src]="
                              rating.star_collected > 0
                                ? 'assets/images/small-star.svg'
                                : 'assets/images/star-inactive.svg'
                            "
                                  alt="Lock"
                                  />
                                </li>
                                <li class="more-space">
                                  <img
                                    class="center-star"
                            [src]="
                              rating.star_collected > 1
                                ? 'assets/images/small-star.svg'
                                : 'assets/images/star-inactive.svg'
                            "
                                    alt="Lock"
                                    />
                                  </li>
                                  <li>
                                    <img
                                      class="two-stars"
                            [src]="
                              rating.star_collected > 2
                                ? 'assets/images/small-star.svg'
                                : 'assets/images/star-inactive.svg'
                            "
                                      alt="Lock"
                                      />
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </ng-template>
                          </swiper>
                        </ion-col>
                        <ion-col style="text-align: center" size="2">
                          <ion-button (click)="slideNext()" class="backBtn" id="slideNext">
                            <ion-icon class="arrow-right" name="arrow-forward"></ion-icon>
                          </ion-button>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </section> -->
                  <!-- new slider starts -->
                  <section class="progress-section">
                    <swiper #progressSlides [config]="slidesOptions" class="levelsSwiper">
                      @for (slides of levelsSliderArr; track slides; let i = $index) {
                        <ng-template swiperSlide>
                          <ion-row>
                            @for (goal of slides; track goal; let ind = $index) {
                              <ion-col
                                size="3"
                                [ngClass]="ind == 8 ? 'lastrow' : ind == 9 ? 'frow' : ''"
                                >
                                <div class="progress-box">
                                  @if (goal?.goal_status != 'Locked') {
                                    <div
                                      class="inner-box"
                    [ngClass]="{
                      'orange-bg': goal?.goal_status == 'Next',
                      'unlocked-color': goal.star_collected > 0
                    }"
                                      >
                                      {{ goal?.goal_number }}
                                    </div>
                                  }
                                  @if (goal?.goal_status == 'Locked') {
                                    <div class="inner-box">
                                      <img src="assets/images/lock.svg" alt="Lock" />
                                    </div>
                                  }
                                  @if (goal.star_collected > 0) {
                                    <div class="stars-con">
                                      <ul>
                                        <li>
                                          <img
                                            class="two-stars"
                          [src]="
                            goal.star_collected > 0 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                            alt="Lock"
                                            />
                                          </li>
                                          <li class="more-space">
                                            <img
                                              class="center-star"
                          [src]="
                            goal.star_collected > 1 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                              alt="Lock"
                                              />
                                            </li>
                                            <li>
                                              <img
                                                class="two-stars"
                          [src]="
                            goal.star_collected > 2 ? 'assets/images/small-star.svg' : 'assets/images/star-inactive.svg'
                          "
                                                alt="Lock"
                                                />
                                              </li>
                                            </ul>
                                          </div>
                                        }
                                      </div>
                                    </ion-col>
                                  }
                                </ion-row>
                              </ng-template>
                            }
                          </swiper>
                        </section>
                        <div class="arrows-container">
                          <div class="arrows">
                            <ion-icon name="chevron-back-outline" (click)="slidePrevNew()" class="slider-prev-icon"></ion-icon>
                            <ion-icon name="chevron-forward-outline" (click)="slideNextNew()" class="slider-next-icon"></ion-icon>
                          </div>
                        </div>
                        <!-- new slider ends -->
                        <!-- stars-achieved section starts here -->
                        @if (gameInfo?.inprogress_prize_count) {
                          <section class="stars-achieved">
                            <h2>
                              {{
                              ("game_details_page.stars_achieved" | translate)
                              ? ("game_details_page.stars_achieved" | translate)
                              : "Stars achieved"
                              }}
                              <span class="big-font"
                                >{{ gameInfo?.star_collected }}<img class="start-img" alt="start" src="assets/images/star.svg"
                              /></span>
                            </h2>
                            @for (inprogress of gameInfo.prize_details; track inprogress) {
                              <ion-list>
                                <ion-item lines="full">
                                  <ion-grid class="star-achieved-wrapper">
                                    <ion-row class="ion-align-items-center star-content-wrapper">
                                      <img alt="shield" src="{{ inprogress?.prize_image }}" class="shield-size" />
                                      <ion-col size="9" class="ion-no-padding cash-content-wrapper">
                                        <ion-row>
                                          <ion-col size="6">
                                            <ion-label class="star-achieved-alignment">
                                              <p class="small-font">
                                                {{
                                                ("game_details_page.prize_to_win" | translate)
                                                ? ("game_details_page.prize_to_win" | translate)
                                                : "Prize to win"
                                                }}
                                              </p>
                                              <h3>{{ inprogress?.prize }}</h3>
                                            </ion-label>
                                          </ion-col>
                                          <ion-col size="6">
                                            <ion-label class="text-right">
                                              <span
                          [ngClass]="{
                            'blue-color': inprogress?.prize_image.search('prize-4') > -1,
                            'orange-color': inprogress?.prize_image.search('prize-3') > -1,
                            'gray-color': inprogress?.prize_image.search('prize-2') > -1,
                            'brown-color': inprogress?.prize_image.search('prize-1') > -1
                          }"
                                                class="orange-color"
                                                >{{ inprogress?.star_required }}
                                                {{
                                                ("game_details_page.stars" | translate) ? ("game_details_page.stars" | translate) : "Stars"
                                                }}</span
                                                >
                                              </ion-label>
                                            </ion-col>
                                          </ion-row>
                                          <div
                    [ngClass]="{
                      gold: inprogress?.prize_image.search('prize-4') > -1,
                      orange: inprogress?.prize_image.search('prize-3') > -1,
                      gray: inprogress?.prize_image.search('prize-2') > -1,
                      brown: inprogress?.prize_image.search('prize-1') > -1
                    }"
                                            >
                                            <ion-progress-bar color="primary" value="{{ inprogress?.progress / 100 }}"></ion-progress-bar>
                                          </div>
                                        </ion-col>
                                      </ion-row>
                                    </ion-grid>
                                  </ion-item>
                                </ion-list>
                              }
                            </section>
                          }
                          <!-- prizes-achieved section starts here -->
                          @if (gameInfo?.achieved_prize_count) {
                            <section class="prizes-achieved">
                              <h2>Prizes achieved</h2>
                              @for (achieved of gameInfo.prize_details; track achieved) {
                                <ion-list>
                                  <ion-item lines="full" class="alignment-item">
                                    <img alt="brown-shield" src="{{ achieved?.prize_image }}" class="shield-size" />
                                    <ion-label class="alignment-lables">
                                      <h3 class="light-color">{{ achieved?.prize_value }}</h3>
                                      <p class="small-font">
                                        {{
                                        ("game_details_page.achieved" | translate) ? ("game_details_page.achieved" | translate) : "Achieved"
                                        }}
                                      </p>
                                    </ion-label>
                                    <ion-label class="text-right">
                                      <img alt="win-icon" src="assets/images/win-icon.svg" class="win-icon" />
                                    </ion-label>
                                  </ion-item>
                                </ion-list>
                              }
                            </section>
                          }
                          <!-- screenshot section starts here -->
                          <section class="screenshot">
                            <h2>
                              {{
                              ("game_details_page.screenshots" | translate)
                              ? ("game_details_page.screenshots" | translate)
                              : "Screenshots"
                              }}
                            </h2>
                            <ion-grid class="ion-no-padding">
                              <ion-row class="screenshot-row">
                                @for (sc of gameInfo?.screen_shot; track sc) {
                                  <ion-col class="screenshot-alignment ion-no-padding">
                                    <div class="screenshot-box">
                                      <img ionImgViewer src="{{ sc }}" alt="Lock" ionImgViewer />
                                    </div>
                                  </ion-col>
                                }
                              </ion-row>
                            </ion-grid>
                          </section>
                        </div>
                        <div class="button-wrapper">
                          <ion-button expand="block" shape="round" class="play-now" [disabled]="isButtonDisabled" (click)="playGame(gameInfo); startSpinner()">
                            @if (!spinnerAnimation && proceed) {
                              <span>{{
                                ("game_details_page.play_now" | translate) ? ("game_details_page.play_now" | translate) : "Play now"
                              }}</span>
                            }
                            @if (spinnerAnimation && proceed) {
                              <div class="spinners">
                                <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="30">
                                </mat-progress-spinner>
                              </div>
                            }
                            @if (!proceed && !spinnerAnimation) {
                              <mat-icon [@bounceIn] class="tick-mark">{{
                                ("game_details_page.done_btn" | translate) ? ("game_details_page.done_btn" | translate) : "done"
                              }}</mat-icon>
                            }
                          </ion-button>
                        </div>
                      </div>
                    } @else {
                      <app-in-progress-animation></app-in-progress-animation>
                    }
                  </ion-content>
